import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
//import { Layout } from './components/Layout';
import './custom.css';
import { RBILLC } from "./components/Home"; 
import {
    FluentProvider,
    webLightTheme,
    Button
} from "@fluentui/react-components"; 

  

export default class App extends Component {
    static displayName = App.name;

    render() {
        return ( 
            <FluentProvider theme={webLightTheme}> 
                <RBILLC></RBILLC>
            </FluentProvider>
        );
    }
}

